import { Table as RbTable } from 'react-bootstrap'
import styled, { css } from 'styled-components'
import { FaSortAmountDown, FaSortAmountUp } from 'react-icons/fa'

const sortStyle = css`
  color: ${({ theme }) => theme.palette.grayscale[5]};
  font-size: 1rem;
  margin-left: 0.2rem;
  margin-right: 0.5rem;
  cursor: pointer;

  ${({ active }) =>
    active &&
    css`
      color: ${({ theme }) => theme.link.color};
    `}
`

export const Table = styled(RbTable)`
  font-size: 0.8rem;
  color: ${({ theme }) => theme.palette.grayscale[2]};
  thead {
    th {
      border-top: unset;
      border-left: 1px solid ${({ theme }) => theme.palette.grayscale[2]};
      border-bottom: 1px solid ${({ theme }) => theme.palette.grayscale[2]};
      white-space: nowrap;

      &:first-child {
        border-left: unset;
      }
    }
  }

  td {
    max-width: 10rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0.4rem;
    border-top: unset;
    border-bottom: 1px solid ${({ theme }) => theme.palette.grayscale[6]};

    &.columnResizer {
      border-bottom: 1px solid;
      width: 1px;
    }
  }

`

export const PaginationContainer = styled.div`
  > div {
    font-size: 0.8rem;
  }
`

export const SortAmountDown = styled(FaSortAmountDown)`
  ${sortStyle}
`

export const SortAmountUp = styled(FaSortAmountUp)`
  ${sortStyle}
`
